<script lang="ts">
  import type { Page } from "$lib/gpu-glossary";
  import { themeStore } from "$lib/gpu-glossary";
  import NavItem from "./NavItem.svelte";
  import SignUpButton from "./SignUpButton.svelte";
  import ThemeOptions from "./ThemeOptions.svelte";

  export let contents: Page[];
  export let showAdditionalControls = true;
</script>

<div class="border-r-0 py-4 overflow-y-scroll">
  {#if showAdditionalControls}
    <div class="mx-4 mb-4 glossary-font-secondary w-fit">
      <SignUpButton />
    </div>
    <div class="ml-4 sm:mb-7 mb-4 font-medium text-lg">THEME</div>
    <div
      class="ml-4 flex flex-col mb-7 items-start glossary-font-secondary gap-y-2"
    >
      <ThemeOptions />
    </div>
  {/if}
  <div class="ml-4 mb-4 font-medium text-lg">TABLE OF CONTENTS</div>
  <div class="flex flex-col gap-y-2" style:color={$themeStore.primary[80]}>
    {#each contents as section}
      <NavItem {section} />
    {/each}
  </div>
</div>
